import { render, staticRenderFns } from "./CustomerNotices.vue?vue&type=template&id=170e8d12&scoped=true&"
import script from "./CustomerNotices.vue?vue&type=script&lang=js&"
export * from "./CustomerNotices.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNotices.vue?vue&type=style&index=0&id=170e8d12&prod&scoped=true&lang=css&"
import style1 from "./CustomerNotices.vue?vue&type=style&index=1&id=170e8d12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170e8d12",
  null
  
)

export default component.exports